import type { BaseClient } from '../../http/BaseClient.js';
import type {
  CreateAgentTemplateRequest,
  ListAgentTemplatesQuery,
  ListAgentTemplatesResponse,
  SimpleAgentResponse,
  Template,
} from './types.js';

const BASE_PATH = '/api/agentengine/v1/agent/templates';

export class TemplatesClient {
  constructor(private readonly http: BaseClient) {}

  list(query: ListAgentTemplatesQuery = {}): Promise<ListAgentTemplatesResponse> {
    return this.http.get<ListAgentTemplatesResponse>(BASE_PATH, { query });
  }

  create(body: CreateAgentTemplateRequest): Promise<Template> {
    return this.http.post<Template>(BASE_PATH, { body });
  }

  delete(templateId: string): Promise<SimpleAgentResponse> {
    return this.http.delete<SimpleAgentResponse>(`${BASE_PATH}/${templateId}`);
  }
}
